import "core-js/modules/es6.regexp.replace";
import _slicedToArray from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import _classCallCheck from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/createClass";
var HELPERS = {
  interopRequireWildcard: "\n    function interopRequireWildcard(obj) {\n      if (obj && obj.__esModule) {\n        return obj;\n      } else {\n        var newObj = {};\n        if (obj != null) {\n          for (var key in obj) {\n            if (Object.prototype.hasOwnProperty.call(obj, key)) {\n              newObj[key] = obj[key];\n            }\n          }\n        }\n        newObj.default = obj;\n        return newObj;\n      }\n    }\n  ",
  interopRequireDefault: "\n    function interopRequireDefault(obj) {\n      return obj && obj.__esModule ? obj : { default: obj };\n    }\n  ",
  createNamedExportFrom: "\n    function createNamedExportFrom(obj, localName, importedName) {\n      Object.defineProperty(exports, localName, {enumerable: true, get: () => obj[importedName]});\n    }\n  ",
  // Note that TypeScript and Babel do this differently; TypeScript does a simple existence
  // check in the exports object and does a plain assignment, whereas Babel uses
  // defineProperty and builds an object of explicitly-exported names so that star exports can
  // always take lower precedence. For now, we do the easier TypeScript thing.
  createStarExport: "\n    function createStarExport(obj) {\n      Object.keys(obj)\n        .filter((key) => key !== \"default\" && key !== \"__esModule\")\n        .forEach((key) => {\n          if (exports.hasOwnProperty(key)) {\n            return;\n          }\n          Object.defineProperty(exports, key, {enumerable: true, get: () => obj[key]});\n        });\n    }\n  "
};
export var HelperManager =
/*#__PURE__*/
function () {
  _createClass(HelperManager, [{
    key: "__init",
    value: function __init() {
      this.helperNames = {};
    }
  }]);

  function HelperManager(nameManager) {
    _classCallCheck(this, HelperManager);

    ;
    this.nameManager = nameManager;

    HelperManager.prototype.__init.call(this);
  }

  _createClass(HelperManager, [{
    key: "getHelperName",
    value: function getHelperName(baseName) {
      var helperName = this.helperNames[baseName];

      if (helperName) {
        return helperName;
      }

      helperName = this.nameManager.claimFreeName("_".concat(baseName));
      this.helperNames[baseName] = helperName;
      return helperName;
    }
  }, {
    key: "emitHelpers",
    value: function emitHelpers() {
      var resultCode = "";

      for (var _i = 0, _Object$entries = Object.entries(HELPERS); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            baseName = _Object$entries$_i[0],
            helperCode = _Object$entries$_i[1];

        var helperName = this.helperNames[baseName];

        if (helperName) {
          resultCode += " ";
          resultCode += helperCode.replace(baseName, helperName).replace(/\s+/g, " ").trim();
        }
      }

      return resultCode;
    }
  }]);

  return HelperManager;
}();